'use es6';

import { connect } from 'react-redux';
import { getConnectedAccounts } from '../../connected-accounts/selectors/getConnectedAccounts';
const mapStateToProps = state => ({
  connectedAccounts: getConnectedAccounts(state)
});
export const withConnectedAccounts = connect(mapStateToProps);